import styled, { css, keyframes } from 'styled-components';

const sirenBlink = keyframes`
  0% {
    box-shadow: 0 0 0 2px #f5222d, 0 2px 8px rgba(245, 34, 45, 0.35);
  }
  50% {
    box-shadow: 0 0 0 2px #faad14, 0 2px 12px rgba(250, 173, 20, 0.45);
  }
  100% {
    box-shadow: 0 0 0 2px #f5222d, 0 2px 8px rgba(245, 34, 45, 0.35);
  }
`;

const sirenTextBlink = keyframes`
  0% { background: #f5222d; }
  50% { background: #faad14; }
  100% { background: #f5222d; }
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 20px 0 4px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${(props) => props.color || '#8c8c8c'};

  &:after {
    content: '';
    flex: 1;
    height: 1px;
    background: #f0f0f0;
  }

  .count {
    font-weight: 400;
    color: #8c8c8c;
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
  padding: 12px 0;
`;

export const TaskCard = styled.div`
  position: relative;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  border-left: 3px solid #d9d9d9;
  padding: 14px 16px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.09);
  }

  ${(props) => props.state === 'normal' && css`
    border-left-color: #faad14;
  `}

  ${(props) => props.state === 'done' && css`
    border-left-color: #52c41a;
    background: #fcfffa;
  `}

  ${(props) => props.state === 'overdue' && css`
    border-left-color: #f5222d;
    background: #fffafa;
  `}

  ${(props) => props.state === 'siren' && css`
    border-color: transparent;
    animation: ${sirenBlink} 1s infinite;
  `}
`;

export const SirenTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 2px 8px;
  border-radius: 10px;
  animation: ${sirenTextBlink} 1s infinite;
`;

export const CardTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardMeta = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const DueLabel = styled.span`
  font-weight: ${(props) => props.emphasis ? 600 : 400};
  color: ${(props) => props.color || '#8c8c8c'};
`;

export const ProgressBar = styled.div`
  height: 5px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 10px;
`;

export const ProgressFill = styled.div`
  height: 100%;
  border-radius: 3px;
  background: ${(props) => props.color || '#52c41a'};
  width: ${(props) => props.percent || 0}%;
  transition: width 0.3s ease;
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #595959;
`;

export const EmptyHint = styled.div`
  padding: 48px 0;
  text-align: center;
  color: #8c8c8c;
`;

// ─── Skeleton loading ────────────────────────────────────────────────────────

const shimmer = keyframes`
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
`;

export const SkeletonBlock = styled.div`
  height: ${(props) => props.height || 14}px;
  width: ${(props) => props.width || '100%'};
  border-radius: ${(props) => (props.round ? '20px' : '6px')};
  background: linear-gradient(90deg, #f0f0f5 25%, #e4e4ec 37%, #f0f0f5 63%);
  background-size: 400% 100%;
  animation: ${shimmer} 1.3s ease infinite;
`;

export const SkeletonCard = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
